import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";

export const SolutionCustomer = ({
  customTitle = null,
  customSubTitle = null,
}) => {
  const { t } = useTranslation();
  const logoList = [
    // {
    //   imgurl: "//files.authing.co/authing-website/brand-state-grid.png",
    //   alt: `authing ${t("common.logo.国家电网")}`,
    // },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-logo-wanke.png",
    //   alt: `authing`,
    // },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-openeuler.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-cnpc-new.png",
      alt: `authing ${t("common.logo.中国石油")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-dongnan-new.png",
      alt: `authing ${t("common.logo.东南大学")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-higer-new.png",
      alt: `authing ${t("common.logo.高等教育出版社")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/brand-logo-zhaoshang.svg",
      alt: `authing ${t("common.logo.招商银行")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-dazhong-new.png",
      alt: `authing`,
    },
    // {
    //   imgurl: "//files.authing.co/authing-website/brand-toyota-red.svg",
    //   alt: `authing ${t("common.logo.丰田")}`,
    // },

    {
      imgurl: "//files.authing.co/authing-website/home-logo-mingyu.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-bentley.png",
      alt: `authing ${t("common.logo.宾利")}`,
    },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-logo-honor.svg",
    //   alt: `authing honor`,
    // },
    // {
    //   imgurl: "//files.authing.co/authing-website/customer-logo-bosch.png",
    //   alt: `authing`,
    // },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-xiandai.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-yishixiehui.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-pingcap.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/brand-logo-jcdecaux.png",
      alt: `authing ${t("common.logo.德高集团")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-yuanqi.png",
      alt: `元气森林单点登录SSO-统一身份认证客户案例`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-treelab-new.png",
      alt: `authing treelab`,
    },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-logo-kingdee-new.png",
    //   alt: `authing ${t("common.logo.金蝶")}`,
    // },
    {
      imgurl: "//files.authing.co/authing-website/logo-changxin.jpeg",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-ey.png",
      alt: `authing ey`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-coca-cola-v2.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-kerui.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/brand-toyota-red.svg",
      alt: `authing`,
    },

    // {
    //   imgurl: "//files.authing.co/authing-website/home-logo-aws-new.png",
    //   alt: `authing ${t("common.logo.亚马逊")}`,
    // },
    // {
    //   imgurl: "//files.authing.co/authing-website/home-logo-agora.png",
    //   alt: `authing ${t("common.logo.宾利")}`,
    // },
    {
      imgurl: "//files.authing.co/authing-website/home-guangda-new.png",
      alt: `authing guangda`,
    },
  ];
  return (
    <section>
      <div className="customer-brand">
        <div className="inner">
          {customTitle ? (
            <Title title={customTitle}>{customSubTitle}</Title>
          ) : (
            <Title title={t("solution.list.customer.title")}></Title>
          )}

          <div className="card-warp">
            {logoList.map((item, index) => {
              return (
                <div className="card" key={index}>
                  <img src={item.imgurl} alt={item.alt} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
